import React from 'react'
import axios from 'axios'
import '../../css/table.css'
import ReactTable from 'react-table'
import { orderBy } from 'lodash'
import Card from 'components/Card/Card.jsx'
import Modal from 'components/Modal/Modal.jsx'
import PartnerForm from '../../forms/PartnerForm.jsx'
import { db, auth } from '../../services/firebase'
import SweetAlert from 'react-bootstrap-sweetalert'
import Button from 'elements/CustomButton/CustomButton.jsx'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { statesOfBrazil } from '../../services/statesOfBrazil'
import SweetSpinner from 'components/SweetSpinner/SweetSpinner.jsx'
import { Grid, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'

const partnerRole = 'lMMk6jd5rhbf710hPdqM'

export default class Partners extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            partners: [],
            discounts: [],
            loading: false,
            partnerModal: false,
            alert: null,
            targetPartner: null,
        }

        this.user = props.user
        this.resetForm = props.resetForm
        this.submitForm = props.submitForm
        this.notify = props.notify
    }

    componentDidMount () {
        this._fetchDiscounts()
        this._fetchPartners()
    }

    render () {
        const { partners, alert, loading } = this.state
        return (
            <div className='main-content'>
                {alert}
                {this.partnerModal()}
                <Card content={
                    <Grid fluid>
                        <Row>
                            <Col md={12}>
                                <Button
                                    bsStyle='default'
                                    wd
                                    className='pull-right'
                                    style={{ marginBottom: 10 }}
                                    onClick={() => {
                                        this.props.resetForm('PartnerForm')
                                        this.setState({ partnerModal: true, targetPartner: null })
                                    }}
                                >
                                    Adicionar Parceiro
                            </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <ReactTable
                                    columns={[
                                        { Header: 'Nome', accessor: 'tradingName' },
                                        { Header: 'Cidade', accessor: 'city' },
                                        { Header: 'Estado', accessor: 'state' },
                                        {
                                            Header: 'Ações', accessor: '',
                                            Cell: ({ value }) => (this._renderTableActions(value))
                                        }
                                    ]}
                                    data={orderBy(partners, ['name', 'asc'])}
                                    onFetchData={this._fetchPartners}
                                    loading={loading}
                                    defaultPageSize={10}
                                    className='-striped -highlight'
                                    previousText='Anterior'
                                    nextText='Próximo'
                                    loadingText='Carregando'
                                    noDataText='Nenhum parceiro encontrado'
                                    pageText='Página'
                                    ofText='de'
                                    rowsText='Registros'
                                />
                            </Col>
                        </Row>
                    </Grid>
                } />
            </div>
        )
    }

    partnerModal = () => {
        const { partnerModal, targetPartner, discounts } = this.state
        return (
            <Modal
                size='modal__big'
                overflowY
                title={targetPartner ? 'Atualizar parceiro' : 'Adicionar parceiro'}
                isOpen={partnerModal}
                content={
                    <PartnerForm
                        initialValues={targetPartner && { ...targetPartner, password: '12345678' }}
                        states={statesOfBrazil()}
                        discounts={discounts}
                        onSubmit={values => {
                            this.setState({ partnerModal: false })
                            if (targetPartner) {
                                this.waitAlert('Atualizando parceiro', true)
                                this._updatePartnerData(values)
                            } else {
                                this.waitAlert('Adicionando parceiro', true)
                                this._createPartnerAccount(values)
                            }
                        }}
                        handleCancel={() => this.setState({ partnerModal: false })}
                    />
                }
            />
        )
    }

    _renderTableActions = value => (
        <div style={{ textAlign: 'center' }}>
            <OverlayTrigger
                placement='top'
                overlay={(<Tooltip id={`edit_${value.id}`}>Editar</Tooltip>)}
            >
                <a
                    className='btn btn-simple btn-default btn-icon'
                    onClick={() => this.setState({ targetPartner: value, partnerModal: true })}
                >
                    <FontAwesomeIcon className='text-dark' icon='edit' />
                </a>
            </OverlayTrigger>

            <OverlayTrigger
                placement='top'
                overlay={(<Tooltip id={`switch_status_${value.id}`}>{value.active ? 'Bloquear Acesso' : 'Desbloquear Acesso'}</Tooltip>)}
            >
                <a
                    className='btn btn-simple btn-default btn-icon'
                    onClick={() => this.enableOrDisablePartner(value)}
                >
                    {
                        value.active
                            ? (<FontAwesomeIcon className='text-dark' icon='lock' />)
                            : (<FontAwesomeIcon className='text-dark' icon='unlock' />)
                    }
                </a>
            </OverlayTrigger>
        </div>
    )

    /**************** 
        Authentication methods
    *****************/

    _createPartnerAccount = data => {
        const { email, password } = data
        auth.createUserWithEmailAndPassword(email, password)
            .then(newUser => this._setPartnerData({ ...data, authID: newUser.uid }))
            .catch(e => this._handleFirebaseAuthenticationErrors(e.code))
    }

    _updatePartnerEmail = (partnerID, newEmail) => {
        axios.put('https://us-central1-enele-e47f5.cloudfunctions.net/updateEmail', { id: partnerID, newEmail })
            .then(() => {
                this.hideAlert()
                this.props.notify('O email de acesso será atualizado em até 5 minutos.', 'success')
            })
            .catch(e => {
                this.hideAlert()
                this.props.notify('Não foi possível alterar o email de acesso.', 'error')
            })
    }

    _lockPartnerAccount = partnerID => {
        axios.put('https://us-central1-enele-e47f5.cloudfunctions.net/lockAccount', { id: partnerID })
            .then(() => {
                this.hideAlert()
                this.props.notify('O acesso será bloqueado em até 5 minutos.', 'success')
            })
            .catch(e => {
                this.hideAlert()
                this.props.notify('Não foi possível bloquear o acesso.', 'error')
            })
    }

    _unlockPartnerAccount = partnerID => {
        axios.put('https://us-central1-enele-e47f5.cloudfunctions.net/unlockAccount', { id: partnerID })
            .then(() => {
                this.hideAlert()
                this.props.notify('O acesso será liberado em até 5 minutos.', 'success')
            })
            .catch(e => {
                this.hideAlert()
                this.props.notify('Não foi possível liberar o acesso.', 'error')
            })
    }

    _handleFirebaseAuthenticationErrors = code => {
        this.hideAlert()
        switch (code) {
            case 'auth/email-already-in-use':
                return this.props.notify('O email informado já está em uso', 'warning')
            default:
                return this.props.notify('Erro ao criar a conta do usuário', 'error')
        }
    }

    /**************** 
        Fetch data from Firestore
    *****************/

    _fetchDiscounts = () => {
        db.collection('discounts').get()
            .then(snapshot => !snapshot.empty && this._passDiscountsToState(snapshot))
            .catch(e => this.props.notify('Erro ao buscar descontos.', 'error'))
    }

    _fetchPartners = () => {
        this.setState({ loading: true })
        db.collection('users').where('role', '==', partnerRole).onSnapshot(snapshot =>
            !snapshot.empty
                ? this._passPartnersToState(snapshot)
                : this.setState({ loading: false })
        )
    }

    /**************** 
        Set data to Firestore
    *****************/

    _setPartnerData = data => {
        const { address, authID, city, cnpj, companyName, district, email, state, tradingName } = data
        db.collection('users').doc(authID).set({
            active: true, //flag for account state
            address,
            city,
            cnpj,
            companyName,
            district,
            email,
            role: partnerRole,
            state: state.value,
            tradingName,
            discount: data.discount ? data.discount.value : null
        })
            .then(() => {
                this.hideAlert()
                this.props.notify('Parceiro adicionado.', 'success')
            })
            .catch(e => {
                this.hideAlert()
                this.props.notify('Erro ao adicionar novo parceiro.', 'error')
            })
    }

    /**************** 
        Update Firestore data
    *****************/

    _updatePartnerData = data => {
        const { targetPartner } = this.state
        const { address, city, cnpj, companyName, district, email, state, tradingName } = data

        db.collection('users').doc(targetPartner.id).update({
            address,
            city,
            cnpj,
            companyName,
            district,
            email,
            state: typeof (state) === 'object' ? state.value : state,
            tradingName,
            discount: data.discount ? this._validateDiscount(data.discount) : null
        })
            .then(() => {
                this.hideAlert()
                this.setState({ targetPartner: null })
                this.props.notify('Parceiro atualizado.', 'success')
                email !== targetPartner.email && this._updatePartnerEmail(targetPartner.id, email)
            })
            .catch(e => {
                this.hideAlert()
                this.setState({ targetPartner: null })
                this.props.notify('Erro ao atualizar parceiro.', 'error')
            })
    }

    _validateDiscount = discount => typeof (discount) === 'object' ? discount.value : discount

    _enablePartner = partnerID => {
        this.hideAlert()
        this.waitAlert('Liberando acesso, aguarde', false)
        db.collection('users').doc(partnerID).update({ active: true })
            .then(() => this._unlockPartnerAccount(partnerID))
            .catch(e => this.props.notify('Erro ao ativar parceiro.', 'error'))
    }

    _disablePartner = partnerID => {
        this.hideAlert()
        this.waitAlert('Bloqueando acesso, aguarde', false)
        db.collection('users').doc(partnerID).update({ active: false })
            .then(() => this._lockPartnerAccount(partnerID))
            .catch(e => this.props.notify('Erro ao desativar parceiro.', 'error'))
    }

    /**************** 
        Pass data to component state
    *****************/

    _passDiscountsToState = discountSnapshot => {
        const discounts = []
        discountSnapshot.forEach(discount =>
            discounts.push({ value: discount.id, label: `${discount.data().name}` })
        )
        return this.setState({ discounts })
    }

    _passPartnersToState = partnerSnapshot => {
        const partners = []
        partnerSnapshot.forEach(partner => partners.push({ ...partner.data(), id: partner.id }))
        this.setState({ partners, loading: false })
    }

    //SweetAlerts
    hideAlert = () => this.setState({ alert: null })

    waitAlert = (title, showSpinner) => {
        this.setState({
            alert: (
                <SweetAlert
                    style={{ display: 'block' }}
                    title={title}
                    onConfirm={() => null}
                    showConfirm={false}
                >
                    {showSpinner ? (<SweetSpinner />) : null}
                </SweetAlert>
            )
        })
    }

    enableOrDisablePartner = partner => {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{ display: "block" }}
                    title="Tem certeza?"
                    onConfirm={() => partner.active
                        ? this._disablePartner(partner.id)
                        : this._enablePartner(partner.id)
                    }
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="default"
                    cancelBtnBsStyle="warning"
                    confirmBtnText="Continuar"
                    cancelBtnText="Cancelar"
                    showCancel
                >
                    {
                        partner.active
                            ? 'O parceiro terá seu acesso bloqueado.'
                            : 'O parceiro terá seu acesso liberado.'
                    }
                </SweetAlert>
            )
        });
    }
}



// WEBPACK FOOTER //
// ./src/views/Partners/Partners.jsx